import {
  failedProvisioningJobsResponseSchema,
  ignoreJobResponseSchema,
  markProvisionedResponseSchema,
  overrideAccessResponseSchema,
  provisioningJobsResponseSchema,
  reprocessJobResponseSchema,
  resolveManualResponseSchema,
  type FailedProvisioningJobsResponse,
  type IgnoreJobRequest,
  type IgnoreJobResponse,
  type MarkProvisionedRequest,
  type MarkProvisionedResponse,
  type OverrideAccessResponse,
  type ProvisioningJobsResponse,
  type ReactivateAccessRequest,
  type ReprocessJobResponse,
  type ResolveManualRequest,
  type ResolveManualResponse,
  type SuspendAccessRequest,
} from '@control-center/shared';

import { apiClient } from './api-client';

export interface FailedJobsFilters {
  saasSlug?: string;
  action?: 'grant' | 'revoke';
  clientId?: string;
  cursor?: string;
  limit?: number;
}

export async function fetchProvisioningJobs(
  status: 'pending' | 'in_progress' | 'provisioned' | 'failed' = 'pending',
): Promise<ProvisioningJobsResponse> {
  const res = await apiClient.get<unknown>(`/api/provisioning/jobs?status=${status}`);
  return provisioningJobsResponseSchema.parse(res.data);
}

export async function markProvisioned(
  jobId: string,
  body: MarkProvisionedRequest,
): Promise<MarkProvisionedResponse> {
  const res = await apiClient.post<unknown>(
    `/api/provisioning/jobs/${jobId}/mark-provisioned`,
    body,
  );
  return markProvisionedResponseSchema.parse(res.data);
}

// Story 12.7 — DLQ de provisioning.

export async function fetchFailedJobs(
  filters: FailedJobsFilters = {},
): Promise<FailedProvisioningJobsResponse> {
  const params = new URLSearchParams();
  if (filters.saasSlug) params.set('saasSlug', filters.saasSlug);
  if (filters.action) params.set('action', filters.action);
  if (filters.clientId) params.set('clientId', filters.clientId);
  if (filters.cursor) params.set('cursor', filters.cursor);
  if (filters.limit) params.set('limit', String(filters.limit));
  const qs = params.toString();
  const res = await apiClient.get<unknown>(`/api/provisioning/jobs/failed${qs ? `?${qs}` : ''}`);
  return failedProvisioningJobsResponseSchema.parse(res.data);
}

export async function reprocessJob(jobId: string): Promise<ReprocessJobResponse> {
  const res = await apiClient.post<unknown>(`/api/provisioning/jobs/${jobId}/reprocess`, {});
  return reprocessJobResponseSchema.parse(res.data);
}

export async function resolveJobManual(
  jobId: string,
  body: ResolveManualRequest,
): Promise<ResolveManualResponse> {
  const res = await apiClient.post<unknown>(`/api/provisioning/jobs/${jobId}/resolve-manual`, body);
  return resolveManualResponseSchema.parse(res.data);
}

export async function ignoreJob(jobId: string, body: IgnoreJobRequest): Promise<IgnoreJobResponse> {
  const res = await apiClient.post<unknown>(`/api/provisioning/jobs/${jobId}/ignore`, body);
  return ignoreJobResponseSchema.parse(res.data);
}

// Story 12.10 — override manual de acesso (suspend/reactivate).

export async function suspendAccess(
  clientId: string,
  body: SuspendAccessRequest,
): Promise<OverrideAccessResponse> {
  const res = await apiClient.post<unknown>(`/api/clients/${clientId}/access/suspend`, body);
  return overrideAccessResponseSchema.parse(res.data);
}

export async function reactivateAccess(
  clientId: string,
  body: ReactivateAccessRequest,
): Promise<OverrideAccessResponse> {
  const res = await apiClient.post<unknown>(`/api/clients/${clientId}/access/reactivate`, body);
  return overrideAccessResponseSchema.parse(res.data);
}
